module.exports = __webpack_public_path__ + "assets/alerts/alert-7b185e05e1dcc05128fcebdf1f7866eb.mp3";